import { CallbackParams, EventType } from './types';

export default class EventEmitter {
  private readonly events = new Map<EventType, Function[]>();

  subscribe(type: EventType, subscriber: Function) {
    const subscribers = this.events.get(type) || [];
    subscribers.push(subscriber);
    this.events.set(type, subscribers);
  }

  removeEvent(type: EventType) {
    this.events.delete(type);
  }

  removeEventSubscriber(type: EventType, subscriber: Function) {
    const subscribers = this.events.get(type) || [];
    this.events.set(
      type,
      subscribers.filter((fn: any) => fn !== subscriber),
    );
  }

  emit(type: EventType, arg: CallbackParams) {
    const subscribers = this.events.get(type) || [];
    subscribers.forEach((callbackFn) => {
      callbackFn(arg);
    });
  }
}
